import React from 'react';
import Menu from '@tencent/dui/lib/components/Menu';
import style from './style.less';
import classNames from 'classnames';

interface Props {
    data: Array<{
        id: string,
        content: string | JSX.Element
    }>;
    selectedId?: string;
    onChange: (selectedId: string) => void;
}
export default function BulletsMenu(props: Props) {
    const { data, selectedId, onChange } = props;
    const handleClick = (id: string) => {
        onChange(id);
    };
    return (
        <Menu
            className={style['bullets-menu']}
            onClick={handleClick}
        >
            {
                data.map(item => (
                    <Menu.Item
                        className={classNames({
                            [style['bullets-menu-item']]: true,
                            [style.selected]: selectedId === item.id,
                        })}
                        key={item.id}
                        id={item.id}
                    >
                        {item.content}
                    </Menu.Item>
                ))
            }
        </Menu>
    );
}
